<style lang="less" scoped>
ul{display: flex;width: 455px;height: 151px;list-style: none;padding: 0;margin-left: 5px;margin-top: 15px;background-color: #d7eefb;}
li{width: 145px;height: 145px;margin: 3px 5px;text-align: left;box-shadow: 0px 0px 3px 2px rgb(240, 239, 239);border-radius: 5px;background-color: rgb(219, 242, 253);}
li:hover{cursor: pointer; .title{color:#13569e;}}
.pic{width: 138px;height: 110px;border-radius: 5px 5px 0px 0px;}
.title{margin: 2px auto;width: 130px;font-size: 16px;text-align: center;}
.dialog{
  /deep/ .el-dialog__header{background: #e8f9ff;text-align: left;height: 20px;}
  p{width: 480px;font-size: 18px;text-align: left;margin: 3px auto;}
}
.v-modal {z-index: 1 !important;}
</style>

<!-- 何宽 2021.9.12
     该组件使用场景：上半部分为一张图片，下半部分为该图片对应的标题。点击将该对象返回给父组件 -->
<template>
  <div class="flfuwu">
    <ul>
      <li v-for="(item, index) in datalist" :key="index" @click="handleClick(item)">
        <img class="pic" :src="item.pic" />
        <p class="title">{{ item.title }}</p>
        <p class="introduce">{{ item.introduce }}</p>
      </li>
      <el-dialog class="dialog" :visible.sync="isdialogVisible">
        <p>
          <span style="font-size: 24px;font-weight: 600;">李主任</span>
          <span style="font-size: 18px;font-weight: 600;margin-left: 20px;">南宁</span>
        </p>
        <p style="margin: 20px auto;border-bottom: solid 2px rgb(212, 211, 211);"></p>
        <p>电 &nbsp;&nbsp;话：0771-2706557</p>
        <p>传 &nbsp;&nbsp;真：0771-2706557</p>
        <p>邮 &nbsp;&nbsp;箱：camining@163.com</p>
        <p>邮 &nbsp;&nbsp;编：530028</p>
        <p>地 &nbsp;&nbsp;址：中国广西壮族自治区南宁市青秀区建政路1号</p>
      </el-dialog>
    </ul>
  </div>
</template>

<script>
export default {
  data()
  {
    return {
      datalist: [
        {pic: 'static/images/官网首页/研究团队.png', title: '研究团队介绍'},
        // {pic: 'static/images/官网首页/常见问题.jpg', title: '常见问题'},
        {pic: 'static/images/官网首页/我要咨询.png', title: '矿业联络咨询'},
        {pic: 'static/images/官网首页/联系专家.png', title: '已开展项目介绍'}
        // {pic: 'static/images/官网首页/联系专家.png', title: '联系专家'}
      ],
      drawer: false,
      titleFixed: false,
      isdialogVisible: false
    }
  },
  created()
  {
    this.titleFixed = false
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleClick(item)
    {
      if (item.title === '研究团队介绍')
      {
        let url = this.$router.resolve({path: '/DXZXteam'})
        window.open(url.href, '_blank')
      }
      else if (item.title === '常见问题')
        this.$message({message: '该模块正在建设中······', type: 'error', customClass: 'mzindex'})
      else if (item.title === '矿业联络咨询')
      {
        // let url = this.$router.resolve({path: '/ZxfwList'})
        // window.open(url.href, '_blank')
        this.$parent.openKyzxfws()
      }
      else
      {
        this.isdialogVisible = true
        this.drawer = true
      }
    },
    handleScroll()
    {
      let offsetTop = this.$refs.pride_tab_fixed.getBoundingClientRect().top
      this.titleFixed = offsetTop < 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/ZXService.vue